/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SuggestedSearch } from './SuggestedSearch';
import {
    SuggestedSearchFromJSON,
    SuggestedSearchFromJSONTyped,
    SuggestedSearchToJSON,
    SuggestedSearchToJSONTyped,
} from './SuggestedSearch';

/**
 * Response to the /suggested_searches
 * @export
 * @interface SuggestedSearchesResponse
 */
export interface SuggestedSearchesResponse {
    /**
     * 
     * @type {Array<SuggestedSearch>}
     * @memberof SuggestedSearchesResponse
     */
    suggestedSearches: Array<SuggestedSearch>;
}

/**
 * Check if a given object implements the SuggestedSearchesResponse interface.
 */
export function instanceOfSuggestedSearchesResponse(value: object): value is SuggestedSearchesResponse {
    if (!('suggestedSearches' in value) || value['suggestedSearches'] === undefined) return false;
    return true;
}

export function SuggestedSearchesResponseFromJSON(json: any): SuggestedSearchesResponse {
    return SuggestedSearchesResponseFromJSONTyped(json, false);
}

export function SuggestedSearchesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuggestedSearchesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestedSearches': ((json['suggested_searches'] as Array<any>).map(SuggestedSearchFromJSON)),
    };
}

export function SuggestedSearchesResponseToJSON(json: any): SuggestedSearchesResponse {
    return SuggestedSearchesResponseToJSONTyped(json, false);
}

export function SuggestedSearchesResponseToJSONTyped(value?: SuggestedSearchesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'suggested_searches': ((value['suggestedSearches'] as Array<any>).map(SuggestedSearchToJSON)),
    };
}

